/** @jsxImportSource davaux/client */
import { createSignal } from 'davaux/client'

/** Props for the CopyButton island component. */
export interface CopyButtonProps {
  /** Text content written to the clipboard when the button is clicked. */
  value: string
  /** Milliseconds to show the copied state before resetting to the default label. */
  timeout?: number
  /** Button label shown in the default (not-yet-copied) state. */
  label?: string
  /** Button label shown immediately after a successful copy. */
  copiedLabel?: string
  /** Additional CSS class names applied to the button element. */
  className?: string
}

export default function CopyButton({
  value,
  timeout = 2000,
  label = 'Copy',
  copiedLabel = 'Copied',
  className,
}: CopyButtonProps) {
  const [copied, setCopied] = createSignal(false)

  function handleCopy() {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), timeout)
    })
  }

  return (
    <button
      type='button'
      class={`dv-copy-button${className ? ` ${className}` : ''}`}
      data-copied={() => copied() || undefined}
      onClick={handleCopy}
    >
      {() => (copied() ? copiedLabel : label)}
    </button>
  )
}
